import { SxProps } from '@mui/material/styles'
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import FieldLabel from '@shared/forms/FieldLabel'
import { ReactNode } from 'react'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

type NumericFormatFieldProps = NumericFormatProps &
  MuiTextFieldProps & {
    label?: ReactNode
    labelStyle?: SxProps
    startAdornment?: ReactNode
    endAdornment?: ReactNode
  }

// Wrapper component that handles the type assertion internally
const NumericFormatField: React.FC<NumericFormatFieldProps> = ({
  label,
  labelStyle,
  startAdornment,
  endAdornment,
  ...props
}) => {
  const numericFormatComponent =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (NumericFormat as any)({
      customInput: MuiTextField,
      InputProps: {
        startAdornment,
        endAdornment,
      },
      ...props,
    })

  if (label) {
    return (
      <>
        <FieldLabel labelStyle={{ mt: 0, ...labelStyle }} htmlFor={props.name}>
          {label}
        </FieldLabel>
        {numericFormatComponent}
      </>
    )
  }

  return numericFormatComponent
}

export default NumericFormatField
